import { Routes, Route } from 'react-router-dom'
import { AssetPage } from '@/components/assets/AssetPage'

export default function AssetsLayout() {
  return (
    <Routes>
      <Route path=":assetKey" element={<AssetPage />} />
      <Route path="bovines" element={<AssetPage />} />
      <Route path="poultry" element={<AssetPage />} />
    </Routes>
  )
}
